// extracted by mini-css-extract-plugin
module.exports = {"gradientGiftIconWrapper":"styles_gradientGiftIconWrapper__f8s_C","container":"styles_container__UAaMB","header":"styles_header__SvXmh","title":"styles_title___sSH9"};